module.exports = __webpack_public_path__ + "18550c6c6672c50af0a1b0d6e9e25a39.pdf";